import { Card } from '@app/components/various/Card';
import { compiledPaths } from '@app/paths';
import { isEmpty } from '@app/utils/isEmpty';
import { ShipmentInvoice } from '@typings';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

interface Props {
  invoices: ShipmentInvoice[];
}

export const ShipmentCardInvoicesAttribute = ({ invoices }: Props) => {
  const { t } = useTranslation(['common']);

  if (isEmpty(invoices)) {
    return <Card.Attribute name={t('common:invoice')} value="-" />;
  }

  return (
    <Card.Attribute
      name={t('common:invoice', { count: invoices.length })}
      value={
        <span className="whitespace-pre">
          {invoices.map((invoice, index) => (
            <React.Fragment key={invoice.invoiceId}>
              {index > 0 && ',  '}
              <Link
                className="relative underline underline-offset-2 after:absolute after:-inset-[7px] focus-visible:focus-outline"
                to={compiledPaths.INVOICE_DETAILS({ invoiceHash: invoice.invoiceHash, invoiceId: invoice.invoiceId })}
              >
                #{invoice.invoiceNumber}
              </Link>
            </React.Fragment>
          ))}
        </span>
      }
    />
  );
};
